import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'questionList',
  props: {
    courseId: {
      type: String,
      default: ''
    },
    courseOpenId: {
      type: String,
      default: ''
    },
    exitIds: {
      type: Array,
      default: ''
    },
    IsTest: {
      type: Boolean,
      default: false
    },
    isclear: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      queTypevalue: '',
      diffTypeValue: '',
      active: '',
      // 被选中的值
      checkedIds: [],
      // 接口数据
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      knowledgeLists: [],
      questionLists: [],
      type: ['', '单选题', '多选题', '判断题', '填空题', '简答题', '综合题'],
      difficult: ['', '简单', '一般', '困难'],
      knowledgeId: '',
      knowledgeName: '',
      page: 1,
      totalCount: 0,
      notsetCount: 0,
      checkedbtn: true,
      checkbtn: false,
      // 获取row的key值
      getRowKeys: function getRowKeys(row) {
        return row.questionId;
      },
      // 选中的行
      checkRow: []
    };
  },
  watch: {
    checkRow: function checkRow(val) {
      var _this = this;

      this.checkedIds = [];
      var checkTotalScore = 0;
      val.forEach(function (element) {
        _this.checkedIds.push(element.questionId);

        if (element.questionType == "综合题") {
          checkTotalScore += 0;
        } else {
          checkTotalScore += 0;
        }
      });
      this.$emit('update:checkedIds', this.checkedIds);
      this.$emit('update:checkTotalScore', checkTotalScore);
    },
    isclear: function isclear() {
      if (this.isclear === 1) {
        this.clearMembers();
      }
    }
  },
  created: function created() {
    console.log(this.courseId);
    this.getKnowledgeList();
  },
  methods: {
    /// 清除弹窗中的选中值
    clearMembers: function clearMembers() {
      this.$refs.multipleTable && this.$refs.multipleTable.clearSelection();
    },
    // 获取知识点数据
    getKnowledgeList: function getKnowledgeList() {
      var that = this;
      this.$http.post("/api/XOrg/BookMaterial/getQuestionKnowledge", {
        courseId: this.courseId,
        courseOpenId: this.courseOpenId
      }).then(function (rst) {
        if (rst && rst.code > 0) {
          that.knowledgeLists = rst.knowledgeList;
          that.page = 1;
          that.getQuestionList();
        }
      });
    },

    /* 获取题库数据 */
    getQuestionList: function getQuestionList() {
      this.checkedbtn = true;
      this.checkbtn = false;
      var that = this;
      this.$http.post("/api/XOrg/BookMaterial/getQuestionList", {
        courseId: this.courseId,
        courseOpenId: this.courseOpenId,
        IsTest: this.IsTest,
        knowledgeId: this.knowledgeId,
        queTypevalue: this.queTypevalue,
        diffTypeValue: this.diffTypeValue,
        page: this.page,
        PageSize: this.pageSize
      }).then(function (rst) {
        that.total = rst.pagination.totalCount;
        that.pageSize = rst.pagination.pageSize;
        that.pageIndex = rst.pagination.pageIndex;
        that.questionLists = rst.list;
        that.questionLists.forEach(function (element) {
          element.questionType = that.type[element.questionType], element.difficulty = that.difficult[element.difficulty];
        });
      });
    },

    /* 获取题库数据 */
    getQuestionListByPage: function getQuestionListByPage(page) {
      var _this2 = this;

      this.checkedbtn = true;
      this.checkbtn = false;
      this.$http.post("/api/XOrg/BookMaterial/getQuestionList", {
        courseId: this.courseId,
        IsTest: this.IsTest,
        knowledgeId: this.knowledgeId,
        queTypevalue: this.queTypevalue,
        diffTypeValue: this.diffTypeValue,
        page: this.page,
        pageSize: this.pageSize
      }).then(function (rst) {
        _this2.total = rst.pagination.totalCount;
        _this2.pageSize = rst.pagination.pageSize;
        _this2.pageIndex = rst.pagination.pageIndex;
        _this2.questionLists = rst.list;

        _this2.questionLists.forEach(function (element) {
          element.questionType = _this2.type[element.questionType], element.difficulty = _this2.difficult[element.difficulty];
        });
      });
      this.clearMembers();
    },

    /* 分页 */
    onPageChangeHandler: function onPageChangeHandler(page) {
      this.page = page;
      this.getQuestionList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.getQuestionList();
    },

    /* 设置选中行 */
    handleSelectionChangeDialog: function handleSelectionChangeDialog(val) {
      this.checkRow = val;
    },

    /* 默认是否已选中 */
    checkboxInit: function checkboxInit(row, index) {
      var IsExit = this.exitIds.indexOf(row.questionId) >= 0;

      if (IsExit) {
        return 0;
      } // 不可勾选
      else return 1; // 可勾选

    },
    checkAll: function checkAll() {
      this.checkbtn = true;
      this.checkedbtn = !this.checkbtn;
    },
    RemoveAllcheck: function RemoveAllcheck() {
      this.checkedbtn = true;
      this.checkbtn = !this.checkedbtn;
    }
  }
};